/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FileViewsQueryVariables = {|
  cwd: string,
  glob?: ?string,
|};
export type FileViewsQueryResponse = {|
  +glob: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
    +path: ?string,
  |}>
|};
export type FileViewsQuery = {|
  variables: FileViewsQueryVariables,
  response: FileViewsQueryResponse,
|};
*/


/*
query FileViewsQuery(
  $cwd: String!
  $glob: String
) {
  glob(cwd: $cwd, query: $glob) {
    id
    name
    path
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cwd"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "glob"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cwd",
        "variableName": "cwd"
      },
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "glob"
      }
    ],
    "concreteType": "File",
    "kind": "LinkedField",
    "name": "glob",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "path",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileViewsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileViewsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b80db3dcedcd98b8df35d13000788cc5",
    "id": null,
    "metadata": {},
    "name": "FileViewsQuery",
    "operationKind": "query",
    "text": "query FileViewsQuery(\n  $cwd: String!\n  $glob: String\n) {\n  glob(cwd: $cwd, query: $glob) {\n    id\n    name\n    path\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7621d577de83db092125221ff157d288';

module.exports = node;
